import { Arrowdown , Calendar2, Calendar4, CardPos, CardReceive, Chart, CheckboxCheck, Download, FolderCheck, LogoBg, MoneyTime, SelectMultiple, TrendUp, vector, vector2, vector3, vector4, vector5, vector6, WalletAdd } from "../../../assets";
import { Layout, LoadingSpinner, PolicyCategoryCard, PolicyInfo, TableRowResponsive, Title } from "../../components";
import { CustomButton } from "../../components";
import { InsurancePolicyDetailsController } from "../../controllers";
import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import { Line } from "react-chartjs-2";
import { Accordion, AccordionDetails, AccordionSummary, LinearProgress } from "@mui/material";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
//START swiper
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import { EffectCreative } from 'swiper/modules';
import 'swiper/css/effect-creative';
import { numberWithCommas, planTypeList } from "../../../core/utils";

// END swiper
class InsurancePolicyDetails extends InsurancePolicyDetailsController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getDetails();
  }
  render() {
    const { policyDetails, base64Loading ,loading, pdf_type , identityInformation, showMore , beneficiaryList, anchorEl, selectedItem, beneficiary, showDeathB, showLifeB , relationPersonList } = this.state;
    return (
      <Layout noBg noPadding title="بیمه نامه  ">
        <Helmet>
          <title> بیمه نامه | بیمه زندگی هامرز </title>
        </Helmet>
        {loading ?
          <LinearProgress />
          :
          <>
               <div className="insurance-policy-details scrollbar ps-0 hide-mobile">
          <div className="insurance-policy-details-info">
            <div className="w-100">
          <Title text="اطلاعات اصلی بیمه نامه " />
              <div className="row-item">
                <PolicyInfo icon={FolderCheck} myStyle="" title="بیمه نامه:" subTitle={`${planTypeList.filter((p: { value: string; }) => p.value ===  policyDetails?.policy?.insurance_type)[0]?.title}`} />
                <PolicyInfo myStyle="" title="شماره بیمه نامه :" subTitle={policyDetails?.policy?.idinsu} icon={vector2} />
                <PolicyInfo myStyle="" title="مدت بیمه نامه:" subTitle={`${policyDetails?.policy?.duration} سال`} icon={vector} />
                <PolicyInfo myStyle="" icon={CardPos} title="نحوه پرداخت:" subTitle={policyDetails?.policy?.payment_method} />
                
              </div>
              <div className="row-item without-btn">

                
                <PolicyInfo icon={MoneyTime} myStyle="" title="مدت پرداخت حق بیمه:" subTitle={`${policyDetails?.policy?.payment_duration} سال`} />
                <PolicyInfo icon={CardReceive} myStyle="" title="مبلغ اورده اولیه:" subTitle={`${policyDetails?.policy?.saveing} ریال`} />
                <PolicyInfo icon={WalletAdd} myStyle="" title="حق بیمه پرداختی:" subTitle={`${numberWithCommas(policyDetails?.policy?.first_payment) || "--"} ریال`} />
                <PolicyInfo icon={TrendUp}  myStyle="" title="درصد افزایش سالانه حق بیمه:" subTitle={`${policyDetails?.policy?.adjustment_coefficient_permium} درصد`} />
              </div>


              <div className="row-item without-btn justify-content-start">

                
<PolicyInfo icon={Calendar4} myStyle="" title="شروع بیمه نامه: " subTitle={`${policyDetails?.policy?.start_date} `} />
<PolicyInfo icon={Calendar2} myStyle="" title="پایان بیمه نامه:" subTitle={`${policyDetails?.policy?.end_date} `} />

</div>
            </div>
            <div>
              <Button
                id="basic-button"
                aria-controls={Boolean(anchorEl) ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={Boolean(anchorEl) ? 'true' : undefined}
                onClick={this.handleClick}
                className="download-btn"
                // loading={base64loading}
              >
                <img src={Download} alt="هامرز"/>  دانلود   <Arrowdown color="#ffffff" />
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                {base64Loading ? 
                <MenuItem className="download-item w-100" >
                {/* <div className="handle-loading-btn search-container-icon pt-2 "> */}
                <LoadingSpinner />
                {/* </div> */}
                </MenuItem>
                :
                <>
                <MenuItem className="download-item" onClick={()=>this.getDownload("UNIVERSAL_PRINT")}>جدول تعهدات</MenuItem>
                <MenuItem className="download-item" onClick={()=>this.getDownload("UNIVERSAL_OFFER_PRINT")}>پیشنهادات</MenuItem>
                <MenuItem className="download-item" onClick={()=>this.getDownload("FACE_PRINT")}>بیمه نامه </MenuItem>
                </>
              }
              </Menu>
            </div>
          </div>
        {/* {policyDetails?.policy?.insurance_type === "UniversalUnitlink" || policyDetails?.policy?.insurance_type === "UniversalHousing" ?  */}
 
        <div className="insurance-policy-details-info mt-2">
            <div className="w-100 ">
            <Title text={policyDetails?.policy?.insurance_type === "UniversalHousing" ? "اطلاعات پروژه" : "اطلاعات صندوق"} />
            {policyDetails?.projects?.map((item: any, index: number) => {
             return (
              <>
              <div className="row-item without-btn">
                <PolicyInfo icon={vector2} myStyle="" title="نام پروژه :" subTitle={`${item?.title} `} />
                <PolicyInfo icon={vector5} myStyle="" title="درصد سهم: " subTitle={`${item?.percent} درصد `} />
                <PolicyInfo icon={FolderCheck} myStyle="" title={policyDetails?.policy?.insurance_type === "UniversalHousing" ?  "متراژ خریداری شده:" : "مقدار واحد خریداری شده "} subTitle={`${item?.unit_count}  `} />
              </div>
              </>
            )
            })}
            </div>
        </div>
        {/* :
        null
        } */}
          <div className="ip-sg-container">
            <div className={`${policyDetails?.policy?.insurance_type === "UniversalHousing" ? "w-100" : ""} ip-sg-container-item `}>
              <Title text={`اطلاعات هویتی  ${identityInformation === 1 ? "بیمه گذار" : "بیمه شده"} `} icon={vector4} >
                <div className="tab hide-mobile">

                  <CustomButton myStyle={`button ${identityInformation === 1 ? " button-active " : ""}`} title="اطلاعات بیمه گذار" onClick={() => this.setState({ identityInformation: 1 })} />
                  <CustomButton myStyle={`button ${identityInformation === 0 ? " button-active " : ""}`} title="اطلاعات بیمه شده" onClick={() => this.setState({ identityInformation: 0 })} />
                </div>
              </Title>
              <div className="tab hide-desktop">

                <CustomButton myStyle={`button ${identityInformation === 1 ? " button-active " : ""}`} title="اطلاعات بیمه گذار" onClick={() => this.setState({ identityInformation: 1 })} />
                <CustomButton myStyle={`button ${identityInformation === 0 ? " button-active " : ""}`} title="اطلاعات بیمه شده" onClick={() => this.setState({ identityInformation: 0 })} />
              </div>
              <div className="stunted-growth">
                <PolicyInfo myStyle="col-md-4" title="نام:" subTitle={identityInformation === 1 ? policyDetails?.policy_holder?.first_name : policyDetails?.insured?.first_name} />
                <PolicyInfo myStyle="col-md-4" title="نام خانوادگی:" subTitle={identityInformation === 1 ? policyDetails?.policy_holder?.last_name : policyDetails?.insured?.last_name} />
                <PolicyInfo myStyle="col-md-4" title="کد ملی:" subTitle={identityInformation === 1 ? policyDetails?.policy_holder?.national_code : policyDetails?.insured?.national_code} />
                <PolicyInfo myStyle="col-md-4" title="تاریخ تولد:" subTitle={identityInformation === 1 ? policyDetails?.policy_holder?.birth_date : policyDetails?.insured?.birth_date} />
                <PolicyInfo myStyle="col-md-4" title="شغل:" subTitle={identityInformation === 1 ? policyDetails?.policy_holder?.job : policyDetails?.insured?.job} />
                <PolicyInfo myStyle="col-md-4" title="خطرات اضافه:" subTitle={identityInformation === 1 ? policyDetails?.policy_holder?.extra_risk_coverage : policyDetails?.insured?.extra_risk_coverage} />
                <PolicyInfo myStyle="col-md-4" title="نام پدر:" subTitle={identityInformation === 1 ? policyDetails?.policy_holder?.father_name : policyDetails?.insured?.father_name} />
                <PolicyInfo myStyle="col-md-4" title="شماره موبایل:" subTitle={identityInformation === 1 ? policyDetails?.policy_holder?.mobile : policyDetails?.insured?.mobile} />
                <PolicyInfo myStyle="col-md-4" title="وضعیت تاهل:" subTitle={identityInformation === 1 ? policyDetails?.policy_holder?.is_married ? "متاهل" : "مجرد" : policyDetails?.insured?.is_married ? "متاهل" : "مجرد"} />
              </div>
            </div>
            {policyDetails?.policy?.insurance_type !== "UniversalHousing" &&

            <div className="ip-sg-container-item ">
              <Title text="پوشش های بیمه" icon={SelectMultiple} />
              <div className="stunted-growth">
                <PolicyInfo myStyle="col-md-4" title="پوشش معافیت از پرداخت حق بیمه:" subTitle={`حادثه: ${policyDetails?.coverages?.has_waiver_accident_policy_holder ? "بله" : "خیر"} | بیماری : ${policyDetails?.coverages?.has_waiver_diseases_policy_holder ? "بله" : "خیر"}`} />
                <PolicyInfo myStyle="col-md-4" title="پوشش سرطان:" subTitle={`${policyDetails?.coverages?.cancer_coverage} درصد`} />
                <PolicyInfo myStyle="col-md-4" title="پوشش فوت به علت حادثه:" subTitle={`${policyDetails?.coverages?.accident_death_coverage} برابر `} />
                <PolicyInfo myStyle="col-md-4" title=" پوشش غرامت روزانه عمومی:" subTitle={policyDetails?.coverages?.has_temporary_disability_coverage ? "بله" : "خیر"} />
                <PolicyInfo myStyle="col-md-4" title="پوشش امراض خاص :" subTitle={`اصلی: ${policyDetails?.coverages?.main_special_diseases_coverage} درصد  | تکمیلی: ${policyDetails?.coverages?.has_supplementary_special_diseases_coverage ? "بله" : "خیر"}  `} />
                <PolicyInfo myStyle="col-md-4" title="پوشش غرامت بستری:" subTitle={policyDetails?.coverages?.has_hos_benefit_coverage ? "بله" : "خیر"} />
                <PolicyInfo myStyle="col-md-4" title="پوشش نقص عضو:" subTitle={`${policyDetails?.coverages?.temporary_and_permanent_disability_coverage} درصد`} />
                <PolicyInfo myStyle="col-md-4" title="ضریب تعدیل سرمایه فوت" subTitle={`${policyDetails?.coverages?.adjustment_coefficient_death_benefit} درصد`} />
                <PolicyInfo
                  myStyle="col-md-4" title="پرداخت مستمری ازکارافتادگی دائم :" subTitle={`حادثه ${policyDetails?.coverages?.annuity_disability_coverage_accident} درصد   | 
                بیماری    ${policyDetails?.coverages?.annuity_disability_coverage_disease} درصد`} />
              </div>
            </div>
  }
          </div>
          <div className="beneficiary">
            <Title text="استفاده کنندگان بیمه نامه" icon={vector3} >


              <>
                <div className="tab hide-mobile">

                  <CustomButton myStyle={`button ${beneficiary === 1 ? " button-active " : ""}`} title="در صورت حیات" onClick={() => this.setState({ beneficiary: 1, beneficiaryList: policyDetails?.life_benefit })} />
                  <CustomButton myStyle={`button ${beneficiary === 0 ? " button-active " : ""}`} title="در صورت فوت" onClick={() => this.setState({ beneficiary: 0, beneficiaryList: policyDetails?.death_benefit })} />
                </div>
                <div className="more" onClick={() => this.setState({ showMore: !showMore })}>
                  مشاهده   <Arrowdown myStyle={showMore ? "arrow-up" : ""} />
                </div>
              </>
            </Title>
            {showMore ?
              <>
                <div className="policy table-responsive mt-3">
                  <table className="table hide-mobile">
                    <thead>
                      <tr>
                        <th scope="col">ردیف</th>
                        <th scope="col">نام و نام خانوادگی</th>
                        <th scope="col">کد ملی</th>
                        <th scope="col">اولویت</th>
                        <th scope="col">درصد سهم </th>
                        <th scope="col">  نسبت  </th>
                      </tr>
                    </thead>
                    <tbody>
                      {beneficiaryList?.map((item: any, index: number) => {
                        return (
                          <tr>
                            <th>{index + 1}</th>
                            <td>{item?.person || "--" }</td>
                            <td>{item?.national_code || "--" }</td>
                            <td>{item?.priority || "--"  }</td>
                            <td>{item?.percent || "--" }</td>
                            <td>{relationPersonList?.find((element: { value: any; }) => element?.value === item?.relation_id)?.title} </td>

                            
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>

              </>
              : null
            }
          </div>
        {policyDetails?.policy?.insurance_type !== "UniversalHousing" && 
          <div className="chart-selected-funds">
            <div className="chart-selected-funds-headline">
              <span className="title">
                <img src={Chart} className="ms-2" alt="هامرز"/>
                رشد اندوخته 
              </span>

              <div className="chart-title">
                <div className="roshd">
                  <span className="roshd-badge t"></span>
                  <span className="roshd-title"> رشد تضمینی (ریال)    </span>

                </div>
                <div className="roshd ">
                  <span className="roshd-badge p"></span>
                  <span className="roshd-title"> رشد پیش بینی شده (ریال) </span>

                </div>
              </div>
            </div>


            <Line
              width={100}
              height={100}
              data={this.state.data}
              options={this.state.options}
            />


          </div>
        }
        </div>

        <div className="insurance-policy-details ps-0 hide-desktop scrollbar">

          <div className="category-sliders hide-desktop">
            <Swiper
              slidesPerView="auto"
              spaceBetween={7}
              pagination={{
                clickable: true,
              }}
              navigation={true}
              // virtual
              // className="details-swiper-slide"
              >
              <SwiperSlide>
                <PolicyCategoryCard onClick={() =>  this.sliderRef1.current.swiper.slideTo(0)} isActive={selectedItem === 0} title="اطلاعات اصلی بیمه نامه" />
              </SwiperSlide >
              <SwiperSlide>
                <PolicyCategoryCard onClick={() =>  this.sliderRef1.current.swiper.slideTo(1)} isActive={selectedItem === 1} title={policyDetails?.policy?.insurance_type === "UniversalHousing" ? "اطلاعات پروژه" : "اطلاعات صندوق"} />
              </SwiperSlide >
              <SwiperSlide>
                <PolicyCategoryCard onClick={() =>  this.sliderRef1.current.swiper.slideTo(2)} isActive={selectedItem === 2} title="اطلاعات هویتی" />
              </SwiperSlide >
              <SwiperSlide>
                <PolicyCategoryCard onClick={() =>  this.sliderRef1.current.swiper.slideTo(3)} isActive={selectedItem === 3} title="پوشش های بیمه نامه" />
              </SwiperSlide >
              <SwiperSlide>
                <PolicyCategoryCard onClick={() =>  this.sliderRef1.current.swiper.slideTo(4)} isActive={selectedItem === 4} title="استفاده کنندگان" />
              </SwiperSlide >
        {policyDetails?.policy?.insurance_type !== "UniversalHousing" && 

              <SwiperSlide>
                <PolicyCategoryCard onClick={() =>  this.sliderRef1.current.swiper.slideTo(5)} isActive={selectedItem === 5} title="نمودار" />
              </SwiperSlide >
  }

              

            </Swiper>
          </div>
          {/* <div className="insurance-policy-details-info mt-2">
            <div className="w-100">
            <Title text="اطلاعات نماینده " />
              
              <div className="row-item without-btn">
                <PolicyInfo icon={vector2} myStyle="" title="نام:" subTitle={`${policyDetails?.brag?.name} `} />
                <PolicyInfo icon={vector5} myStyle="" title="وضعیت: " subTitle={`${policyDetails?.brag?.active ? "فعال" : "غیر فعال"} `} />
                <PolicyInfo icon={FolderCheck} myStyle="" title="ادرس:" subTitle={`${policyDetails?.brag?.address} `} />
                <PolicyInfo icon={vector6} myStyle="" title="کد:" subTitle={`${policyDetails?.brag?.code || "--"} `} />
              </div>
            </div>
        </div> */}

          <Swiper
              ref={this.sliderRef1}
             grabCursor={true}
             effect={'creative'}
             creativeEffect={{
                 next: {
                 shadow: true,
                 translate: [0, 0, -400],
               },
               prev: {
                 translate: ['100%', 0, 0],
               },
             }}
             modules={[EffectCreative]}
             className="swiper-creative"
             onSlideChange={(e:any) => this.setState({selectedItem : e.realIndex})}
          >
            <SwiperSlide>

              <>
                <div className="insurance-policy-details-info" style={{backgroundImage: `url(${LogoBg})`}}>
                  <PolicyInfo myStyle="col-md-12" icon={FolderCheck} title="بیمه نامه:" subTitle={`${planTypeList.filter((p: { value: string; }) => p.value ===  policyDetails?.policy?.insurance_type)[0]?.title}`} />
                  <PolicyInfo myStyle="col-6" title="شماره بیمه نامه :" subTitle={policyDetails?.policy?.idinsu} icon={vector2} />
                  <PolicyInfo myStyle="col-6" title="مدت بیمه نامه:" subTitle={`${policyDetails?.policy?.duration} سال`} icon={vector} />
                  <PolicyInfo myStyle="col-6" icon={CheckboxCheck} title="نحوه پرداخت:" subTitle={policyDetails?.policy?.payment_method} />
                  <PolicyInfo myStyle="col-6" icon={vector5} title="مدت پرداخت حق بیمه:" subTitle={`${policyDetails?.policy?.payment_duration} سال`} />
                  <PolicyInfo myStyle="col-6" icon={FolderCheck} title="مبلغ اورده اولیه:" subTitle={`${numberWithCommas(policyDetails?.policy?.saveing)} ریال`} />
                  <PolicyInfo myStyle="col-6" icon={vector6} title="حق بیمه پرداختی:" subTitle={`${numberWithCommas(policyDetails?.policy?.first_payment) || "--"} ریال`} />
                  <PolicyInfo myStyle="col-6" icon={vector2} title="درصد افزایش سالانه حق بیمه:" subTitle={`${policyDetails?.policy?.adjustment_coefficient_permium} درصد`} />
                  <PolicyInfo myStyle="col-6"  icon={vector5}  title="شروع بیمه نامه: " subTitle={`${policyDetails?.policy?.start_date} `} />
                  <PolicyInfo icon={FolderCheck} myStyle="col-6"  title="پایان بیمه نامه:" subTitle={`${policyDetails?.policy?.end_date} `} />

                </div>

                <div className="download-container">
                  <div className="item">
                    <span>جدول تعهدات </span>

                    <Button
                      className="download-btn"


                      onClick={()=>this.getDownload("UNIVERSAL_PRINT")}
                      >
                         {base64Loading && pdf_type === "UNIVERSAL_PRINT" ? <LoadingSpinner/> : 
                      <>
                      <img src={Download} alt="هامرز"/> دانلود  
                      </>
                       }
                    </Button>
                  </div>
                  <div className="item">
                    <span>پیشنهادات</span>
                    <Button
                      className="download-btn"
                      onClick={()=>this.getDownload("UNIVERSAL_OFFER_PRINT")}
                      >
                      {base64Loading && pdf_type === "UNIVERSAL_OFFER_PRINT" ? <LoadingSpinner/> : 
                      <>
                      <img src={Download} alt="هامرز"/> دانلود 
                      </>
                       }
                    </Button>

                  </div>
                  <div className="item">
                    <span> بیمه نامه </span>
                    <Button
                      className="download-btn"
                      onClick={()=>this.getDownload("FACE_PRINT")}
                      >
                          {base64Loading && pdf_type === "FACE_PRINT" ? <LoadingSpinner/> : 
                      <>
                      <img src={Download} alt="هامرز" /> دانلود 
                      </>
                       }
                    </Button>
                  </div>
                </div>
              </>
            </SwiperSlide>




<SwiperSlide>
            <div className="ip-sg-container">
            <div className="ip-sg-container-item ">
            <Title text={policyDetails?.policy?.insurance_type === "UniversalHousing" ? "اطلاعات پروژه" : "اطلاعات صندوق"} />
            {policyDetails?.projects?.map((item: any, index: number) => {
             return (
              <>
              <div className="stunted-growth mt-2">
              <PolicyInfo icon={vector2} myStyle="col-md-4 mb-3" title="نام پروژه :" subTitle={`${item?.title} `} />
                <PolicyInfo icon={vector5} myStyle="col-md-4 mb-3" title="درصد سهم: " subTitle={`${item?.percent} درصد `} />
                <PolicyInfo icon={FolderCheck} myStyle="col-md-4 mb-3" title={policyDetails?.policy?.insurance_type === "UniversalHousing" ?  "متراژ خریداری شده:" : "مقدار واحد خریداری شده "} subTitle={`${item?.unit_count}  `} />
              </div>
              </>
            )
            })}
            </div>
            
        </div>

</SwiperSlide>



            <SwiperSlide> 
              <div className="ip-sg-container">
                <>
                  <div className="ip-sg-container-item ">
                    <Title text={`اطلاعات هویتی بیمه شده `} icon={vector4} />

                    <div className="stunted-growth mt-2">
                      <PolicyInfo myStyle="col-md-4 mb-3" title="نام:" subTitle={policyDetails?.insured?.first_name} />
                      <PolicyInfo myStyle="col-md-4 mb-3" title="نام خانوادگی:" subTitle={policyDetails?.insured?.last_name} />
                      <PolicyInfo myStyle="col-md-4 mb-3" title="کد ملی:" subTitle={policyDetails?.insured?.national_code} />
                      <PolicyInfo myStyle="col-md-4 mb-3" title="تاریخ تولد:" subTitle={policyDetails?.insured?.birth_date} />
                      <PolicyInfo myStyle="col-md-4 mb-3" title="شغل:" subTitle={policyDetails?.insured?.job} />
                      <PolicyInfo myStyle="col-md-4" title="خطرات اضافه:" subTitle={ policyDetails?.insured?.extra_risk_coverage} />
                      <PolicyInfo myStyle="col-md-4 mb-3" title="نام پدر:" subTitle={policyDetails?.insured?.father_name} />
                      <PolicyInfo myStyle="col-md-4 mb-3" title="شماره موبایل:" subTitle={policyDetails?.insured?.mobile} />
                      <PolicyInfo myStyle="col-md-4 mb-3" title="وضعیت تاهل:" subTitle={policyDetails?.insured?.is_married  ? "متاهل" : "مجرد"} />
                    </div>
                  </div>
                  <div className="ip-sg-container-item ">
                    <Title text={`اطلاعات هویتی بیمه گذار `} icon={vector4} />

                    <div className="stunted-growth mt-2">
                      <PolicyInfo myStyle="col-md-4 mb-2" title="نام:" subTitle={policyDetails?.policy_holder?.first_name} />
                      <PolicyInfo myStyle="col-md-4 mb-2" title="نام خانوادگی:" subTitle={policyDetails?.policy_holder?.last_name} />
                      <PolicyInfo myStyle="col-md-4 mb-2" title="کد ملی:" subTitle={policyDetails?.policy_holder?.national_code} />
                      <PolicyInfo myStyle="col-md-4 mb-2" title="تاریخ تولد:" subTitle={policyDetails?.policy_holder?.birth_date} />
                      <PolicyInfo myStyle="col-md-4 mb-2" title="شغل:" subTitle={policyDetails?.policy_holder?.job} />
                      <PolicyInfo myStyle="col-md-4 mb-2" title="خطرات اضافه:" subTitle={policyDetails?.policy_holder?.extra_risk_coverage} />
                      <PolicyInfo myStyle="col-md-4 mb-2" title="نام پدر:" subTitle={policyDetails?.policy_holder?.father_name} />
                      <PolicyInfo myStyle="col-md-4 mb-2" title="شماره موبایل:" subTitle={policyDetails?.policy_holder?.mobile} />
                      <PolicyInfo myStyle="col-md-4 mb-2" title="وضعیت تاهل:" subTitle={policyDetails?.policy_holder?.is_married ? "متاهل" : "مجرد"} />
                    </div>
                  </div>


                </>
              </div>
            </SwiperSlide>
            <SwiperSlide>  
              <div className="ip-sg-container">

                <div className="ip-sg-container-item ">
                  <Title text="پوشش های بیمه" icon={SelectMultiple} />
                  <div className="stunted-growth mt-2">
                    <PolicyInfo myStyle="col-md-4 mb-4" title="پوشش معافیت از پرداخت حق بیمه:" subTitle={`حادثه: ${policyDetails?.coverages?.has_waiver_accident_policy_holder ? "بله" : "خیر"} | بیماری : ${policyDetails?.coverages?.has_waiver_diseases_policy_holder ? "بله" : "خیر"}`} />
                    <PolicyInfo myStyle="col-md-4 mb-4" title="پوشش سرطان:" subTitle={`${policyDetails?.coverages?.cancer_coverage} درصد`} />
                    <PolicyInfo myStyle="col-md-4 mb-4" title="پوشش فوت به علت حادثه:" subTitle={`${policyDetails?.coverages?.accident_death_coverage} برابر `} />
                    <PolicyInfo myStyle="col-md-4 mb-4" title=" پوشش غرامت روزانه عمومی:" subTitle={policyDetails?.coverages?.has_temporary_disability_coverage ? "بله" : "خیر"} />
                    <PolicyInfo myStyle="col-md-4 mb-4" title="پوشش امراض خاص :" subTitle={`اصلی: ${policyDetails?.coverages?.main_special_diseases_coverage} درصد  | تکمیلی: ${policyDetails?.coverages?.has_supplementary_special_diseases_coverage ? "بله" : "خیر"}  `} />
                    <PolicyInfo myStyle="col-md-4 mb-4" title="پوشش غرامت بستری:" subTitle={policyDetails?.coverages?.has_hos_benefit_coverage ? "بله" : "خیر"} />
                    <PolicyInfo myStyle="col-md-4 mb-4" title="پوشش نقص عضو:" subTitle={`${policyDetails?.coverages?.temporary_and_permanent_disability_coverage} درصد`} />
                    <PolicyInfo myStyle="col-md-4 mb-4" title="ضریب تعدیل سرمایه فوت" subTitle={`${policyDetails?.coverages?.adjustment_coefficient_death_benefit} درصد`} />
                    <PolicyInfo
                      myStyle="col-md-4" title="پرداخت مستمری ازکارافتادگی دائم :" subTitle={`حادثه ${policyDetails?.coverages?.annuity_disability_coverage_accident} درصد   | 
      بیماری    ${policyDetails?.coverages?.annuity_disability_coverage_disease} درصد`} />
                  </div>
                </div>
              </div>

            </SwiperSlide>
            <SwiperSlide>
              <>
                <div className="beneficiary">
                  <Title text="استفاده کنندگان در صورت حیات" icon={vector3} >
                    <div className="more" onClick={() => this.setState({ showLifeB: !showLifeB })}>
                      مشاهده   <Arrowdown myStyle={showLifeB ? "arrow-up" : ""} />
                    </div>

                  </Title>
                  {showLifeB ?
                    <>

                      {policyDetails?.life_benefit?.map((item: any, index: number) => {
                        return (
                          <Accordion className="policy-accordion" >
                            <AccordionSummary
                              // expandIcon={<Arrowdown />}
                              aria-controls="panel1a-content"
                              className="summsry"
                              id="panel1a-header"
                              sx={{ border: 0 }}

                            >
                              <TableRowResponsive title="ردیف" value={index + 1} />
                              <TableRowResponsive title="نام و نام خانوادگی" value={item?.person || "--"} />
                              <TableRowResponsive title="کد ملی" value={item?.national_code || "--"} />
                            </AccordionSummary>
                            <AccordionDetails
                              className="d-flex flex-wrap"
                            >
                              <TableRowResponsive title="اولویت" value={item?.priority || "--"} />
                              <TableRowResponsive title=" درصد سهم " value={item?.percent || "--"}  />
                              <TableRowResponsive title="نسبت" value={relationPersonList?.find((element: { value: any; }) => element?.value === item?.relation_id)?.title || "--"} />

                            </AccordionDetails>
                          </Accordion>
                        )
                      })}
                    </>
                    : null
                  }
                </div>
                <div className="beneficiary">
                  <Title text="استفاده کنندگان  در صورت فوت" icon={vector3} >
                    <div className="more" onClick={() => this.setState({ showDeathB: !showDeathB })}>
                      مشاهده   <Arrowdown myStyle={showDeathB ? "arrow-up" : ""} />
                    </div>

                  </Title>
                  {showDeathB ?
                    <>

                      {policyDetails?.death_benefit?.map((item: any, index: number) => {
                        return (
                          <Accordion className="policy-accordion">
                            <AccordionSummary
                              // expandIcon={<Arrowdown />}
                              aria-controls="panel1a-content"
                              className="summsry"
                              id="panel1a-header"
                            >
                              <TableRowResponsive title="ردیف" value={index + 1} />
                              <TableRowResponsive title="نام و نام خانوادگی" value={item?.person || "--"} />
                              <TableRowResponsive title="کد ملی" value={item?.national_code || "--"} />
                            </AccordionSummary>
                            <AccordionDetails
                              className="d-flex flex-wrap"
                            >
                              <TableRowResponsive title="اولویت" value={item?.priority || "--"} />
                              <TableRowResponsive title="درصد سهم" value={item?.percent || "--"} />
                              <TableRowResponsive title="نسبت" value={relationPersonList?.find((element: { value: any; }) => element?.value === item?.relation_id)?.title || "--" } />

                            </AccordionDetails>
                          </Accordion>
                        )
                      })}
                    </>
                    : null
                  }
                </div>
              </>
            </SwiperSlide>
        {policyDetails?.policy?.insurance_type !== "UniversalHousing" && 

            <SwiperSlide>
              <div className="chart-selected-funds">
                <div className="chart-selected-funds-headline">
                  <span className="title">
                    <img src={Chart} className="ms-2" alt="هامرز"/>
                    رشد اندوخته 
                  </span>

                  <div className="chart-title">
                    <div className="roshd">
                      <span className="roshd-badge t"></span>
                      <span className="roshd-title"> رشد تضمینی (ریال) </span>

                    </div>
                    <div className="roshd ">
                      <span className="roshd-badge p"></span>
                      <span className="roshd-title"> 
                      رشد پیش بینی شده (ریال)  </span>

                    </div>
                  </div>
                </div>


                <Line
                  width={100}
                  height={100}
                  data={this.state.data}
                  options={this.state.options}
                />


              </div>
            </SwiperSlide>
        }
        </Swiper>
        </div>
          </>
        }
   
      </Layout>
    )
  }
}
const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    userData: dispatch.general.userData,
  }
};

export default connect(mapStateToProps)(InsurancePolicyDetails);